import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, shadows, spacing }) => ({
  card: {
    borderRadius: spacing(0.5),
    boxShadow: shadows[3],
    cursor: "pointer",
    height: 70,
    marginBottom: spacing(2),
    marginRight: spacing(2),
    padding: spacing(1),
    width: 100,
  },

  "card--active": {
    borderColor: palette.primary.main,
    borderStyle: "solid",
    borderWidth: 2,
  },
  card__image: {
    width: "100%",
  },
}));
